
import React from 'react'
import PropTypes from 'prop-types'
import HeadingImg from '../media/images/footer_title.png'

const HeadingStyles = {
  display: 'block',
  background: `url(${HeadingImg}) repeat-x top left`,
  marginBottom: '35px',
  textAlign: 'center',
  height: '10px',
  width: '86px',
  backgroundSize: 'cover',
  margin: '15px auto 35px',
}

const CustomHeading = props => {
  const { text, className } = props
  return (
    <div className={className}>
      <h2 className="csm_heading">
        {text}
      </h2>
      <div className="center-block text-center">
        <span style={HeadingStyles} />
      </div>
    </div>
  )
}

CustomHeading.propTypes = {
  text: PropTypes.string.isRequired,
}

export default CustomHeading
